var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHealth = function SvgHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    fill: "none",
    viewBox: "0 0 34 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#236A91",
    d: "m4.008 8.93 12.867-5.457L29.742 8.93c.415.175.64.548.633.9-.028 6.426-2.7 17.529-13.1 22.507a.925.925 0 0 1-.794 0C6.075 27.352 3.411 16.257 3.375 9.823c0-.352.218-.718.633-.9v.007Zm27.05-3.108L17.817.204a2.27 2.27 0 0 0-1.885 0L2.693 5.822C1.146 6.476-.007 8.002 0 9.844.035 16.819 2.904 29.58 15.019 35.38a4.295 4.295 0 0 0 3.712 0c12.122-5.8 14.984-18.562 15.019-25.537.007-1.842-1.146-3.368-2.693-4.022ZM9 15.56c0 1.14.457 2.236 1.259 3.045l5.814 5.814a1.129 1.129 0 0 0 1.59 0l5.814-5.814a4.31 4.31 0 0 0-6.096-6.096l-.52.52-.52-.52a4.31 4.31 0 0 0-7.355 3.052H9Z"
  })));
};
export default SvgHealth;